import React, { useId } from 'react';
import { ChevronDown } from 'lucide-react';
import Field, { controlClass } from './Field';
import { cn } from 'lib/utils';

export interface SelectOption {
    value: string | number;
    label: string;
    disabled?: boolean;
}

export interface SelectFieldProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
    label?: React.ReactNode;
    hint?: React.ReactNode;
    error?: string;
    options: SelectOption[];
    /** 빈 값 안내 문구. null이면 빈 옵션을 넣지 않는다 */
    placeholder?: string | null;
    fieldClassName?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    hint,
    error,
    required,
    options,
    placeholder = '선택하세요',
    className = '',
    fieldClassName = '',
    id,
    ...props
}) => {
    const autoId = useId();
    const selectId = id || autoId;

    return (
        <Field label={label} hint={hint} error={error} required={required} htmlFor={selectId} className={fieldClassName}>
            <div className="relative">
                <select
                    id={selectId}
                    required={required}
                    aria-invalid={Boolean(error) || undefined}
                    className={cn(controlClass, 'appearance-none pr-9', className)}
                    {...props}
                >
                    {placeholder !== null && <option value="">{placeholder}</option>}
                    {options.map((option) => (
                        <option key={option.value} value={option.value} disabled={option.disabled}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-500" />
            </div>
        </Field>
    );
};

export default SelectField;
